//- 功能: 前台用户系统的主布局组件
//- 结构:
//- 顶部导航栏：logo、导航菜单（首页、非遗文化、活动、课程、商城、传承人、视频、论坛、通知）
//- 用户功能区：登录/注册、购物车、联系客服、个人中心、退出
//- 主内容区：路由视图容器
//- 页脚：网站底部信息

<template>
    <div>

        <el-container>
            <el-header style="background-color: white;width: 100%;position: fixed;z-index:1000">
                <el-menu :default-active="active" class="main-container" mode="horizontal" text-color="black"
                    active-text-color="var(--primary-color)">
                    <el-menu-item index="">
                        <img style="height: 50px;object-fit: contain;" :src="require('@/assets/logo.png')">
                    </el-menu-item>

                    <el-menu-item index="/Front/Home" @click="ToPath('/Front/Home')">首页</el-menu-item>
                    <el-menu-item index="/Front/CulturalList" @click="ToPath('/Front/CulturalList')">非遗文化</el-menu-item>
                    <el-menu-item index="/Front/ActivityList" @click="ToPath('/Front/ActivityList')">非遗活动</el-menu-item>
                    <el-menu-item index="/Front/CouseList" @click="ToPath('/Front/CouseList')">非遗课程</el-menu-item>
                    <el-menu-item index="/Front/GoodList" @click="ToPath('/Front/GoodList')">周边商城</el-menu-item>
                    <el-menu-item index="/Front/InheritorList" @click="ToPath('/Front/InheritorList')">传承人</el-menu-item>
                    <el-menu-item index="/Front/VideoExhibitionList"
                        @click="ToPath('/Front/VideoExhibitionList')">非遗视频</el-menu-item>
                    <el-menu-item index="/Front/TopicList" @click="ToPath('/Front/TopicList')">非遗论坛</el-menu-item>



                    <el-menu-item index="/Front/SysNoticeList" @click="ToPath('/Front/SysNoticeList')">系统通知</el-menu-item>
                    <el-menu-item index="/Front/PersonCenter" style="float: right;" @click="ToPath('/Front/PersonCenter')"
                        v-if="Token && RoleType == '用户'">{{ UserInfo.UserName }}</el-menu-item>
                    <el-menu-item index="/Front/BuyCard" style="float: right;" v-if="Token && RoleType == '用户'">
                        <RouterLink :to="{ path: '/Front/BuyCard' }"> 我的购物车</RouterLink>
                    </el-menu-item>
                    <el-menu-item index="/Front/WeChat" style="float: right;" @click="Wechat()" v-if="Token">
                        联系客服</el-menu-item>
                    <el-menu-item index="Register" style="float: right;" v-if="!Token"
                        @click="ToRegister()">注册</el-menu-item>
                    <el-menu-item index="Login" style="float: right;" v-if="!Token" @click="ToLogin()">登录</el-menu-item>
                    <el-menu-item @click="LoginOut()" style="float: right;" v-if="Token">退出</el-menu-item>

                </el-menu>

            </el-header>
            <div style="height: 50px;"></div>
            <el-main class="main-container main-box">
                <router-view></router-view>
            </el-main>
            <div style="height: 20px;"></div>
            <Footer></Footer>
        </el-container>


    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Footer from "./Footer.vue"
export default {
    computed: {
        ...mapGetters([
            'Token', 'UserInfo', 'RoleType', 'HasUserInfo', 'ColumnType', "UserId"
        ])
    },
    data() {
        return {
            active: 'home',

        }
    },
    components: {

        Footer
    },
    created() {

    },

    methods: {
        //前往登录
        ToLogin() {
            this.$router.push({
                path: "/Login"
            })
        },
        //前往注册
        ToRegister() {
            this.$router.push({
                path: "/Register"
            })
        },
        //退出
        async LoginOut() {
            await this.$store.dispatch('Logout')
            this.$router.push({
                path: "/Login"
            })
        },
        //跳转
        async ToPath(url) {
            this.$router.push({
                path: url
            })
        },
        //跳转到用户信息
        async ToUserInfo() {
            this.$router.push({
                path: "/Front/UserPerson"
            })
        },
        //跳转到修改密码
        async ToEditPassword() {
            this.$router.push({
                path: "/Front/PasswordEdit"
            })
        },
        //返回上一个页面
        goBack() {
            this.$router.go(-1)
        },
        async Wechat() {
            if (this.Token) {
                await this.$Post("/WechatCollection/InsertWechatCollection", {
                    SelfUserId: this.UserId,
                    OtherUserId: 1
                });
                this.$router.push({
                    path: "/Front/Wechat",
                    query: {
                        OtherUserId: 1
                    }
                })
            }
            else {
                this.$message.error("请先登录再操作");
            }
        }

    },


}
</script>

<style scoped>
.main-container {
    width: var(--content-width);
    margin: 0 auto;
}

.main-box {
    min-height: calc(100vh - 120px);
}

.el-main {
    padding: 20px 0px 0px 0px !important;
    overflow: hidden;
}
</style>
